import { Divider } from "primereact/divider";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useSelector } from "react-redux";

export default function SalesCalculation({ formik }) {
  const { enableCurrency } = useSelector((state) => state.CurrencyReducer);

  const { t } = useTranslation();

  const calculateTotalSalePrice = () => {
    return formik?.values?.products?.reduce(
      (accumulator, currentItem) =>
        accumulator + currentItem?.unit_price * currentItem.quantity,
      0
    );
  };

  const calculateTotalPrice = () => {
    console.log(formik?.values?.products);
    return formik?.values?.products?.reduce(
      (accumulator, currentItem) => accumulator + currentItem.total,
      0
    );
  };

  const calculateTotalPurchasePrice = () => {
    return formik?.values?.products?.reduce(
      (accumulator, currentItem) => accumulator + currentItem.unit_price,
      0
    );
  };
  const calculateTotalDiscount = () => {
    return formik?.values?.products?.reduce(
      (accumulator, currentItem) => accumulator + currentItem.discount,
      0
    );
  };

  const calculateTotalMisc = () => {
    return formik?.values?.products?.reduce(
      (accumulator, currentItem) => accumulator + currentItem.misc_charges,
      0
    );
  };
  useEffect(() => {
    if (formik.values?.products.length > 0) {
      formik.setFieldValue("totalPurchase", calculateTotalPurchasePrice() || 0);
      formik.setFieldValue(
        "totalSales",
        formik.values.saleStatus === "refund"
          ? calculateTotalSalePrice() * -1
          : Math.abs(calculateTotalSalePrice()) || 0
      );
      formik.setFieldValue(
        "totalDiscount",
        formik.values.saleStatus === "refund"
          ? calculateTotalDiscount() * -1
          : Math.abs(calculateTotalDiscount()) || 0
      );
      formik.setFieldValue(
        "totalmiscCharges",
        formik.values.saleStatus === "refund"
          ? calculateTotalMisc() * -1
          : Math.abs(calculateTotalMisc()) || 0
      );
      formik.setFieldValue(
        "totalAmount",
        formik.values.saleStatus === "refund"
          ? calculateTotalPrice() * -1
          : Math.abs(calculateTotalPrice()) || 0
      );
    }
  }, [formik.values?.products, formik.values?.product]);

  return (
    <>
      <div className="w-full lg:w-7/12 xl:w-5/12">
        <div className="card px-4 pt-0 pb-4 shadow-md rounded-lg flex flex-col gap-2">
          <Divider>
            <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
              {formik.values?.saleStatus === "invoice"
                ? t("sales_summary")
                : t("refund_summary")}
            </span>
          </Divider>
          <div className="flex justify-between ">
            <h1 className="text-lg font-semibold">{t("total_items")}</h1>
            <span className="text-lg">{formik?.values?.products?.length}</span>
          </div>

          {/* <div className="flex justify-between gap-2">
            <h1 className="text-lg font-semibold">Total Purchase Price</h1>
            <span className="text-lg">
              {`${enableCurrency?.unit || ""} `} {formik.values?.totalPurchase.toLocaleString("en-IN")}
            </span>
          </div> */}

          <div className="flex justify-between gap-2">
            <h1 className="text-lg font-semibold">
              Total{" "}
              {formik.values?.saleStatus === "invoice"
                ? t("sales")
                : t("refund")}{" "}
              Price
            </h1>
            <span className="text-lg">
              {`${enableCurrency?.unit || ""} `} RS <span> </span>
              {formik.values?.totalSales.toLocaleString("en-IN")}
            </span>
          </div>

          <div className="flex justify-between gap-2">
            <h1 className="text-lg font-semibold">{t("Misc Charges")}</h1>
            <span className="text-lg">
              {`${enableCurrency?.unit || ""} `} RS <span> </span>
              {formik.values?.totalmiscCharges?.toLocaleString("en-IN")}
            </span>
          </div>

          <div className="flex justify-between gap-2">
            <h1 className="text-lg font-semibold">{t("discount")}</h1>
            <span className="text-lg">
              {`${enableCurrency?.unit || ""} `} RS <span> </span>
              {formik.values?.totalDiscount.toLocaleString("en-IN")}
            </span>
          </div>

          {/* <div className="flex justify-between gap-2">
            <h1 className="text-lg font-semibold">{t("vat")} %</h1>
            <span className="text-lg">{formik.values?.vatPer}%</span>
          </div>

          <div className="flex justify-between gap-2">
            <h1 className="text-lg font-semibold">{t("vat_amount")}</h1>
            <span className="text-lg">
              {`${enableCurrency?.unit || ""} `}{" "}
              {formik.values?.vatAmount.toLocaleString("en-IN")}
            </span>
          </div> */}

          <Divider
            pt={{
              root: { className: "!my-2" },
            }}
          />

          <div className="flex justify-end gap-3">
            <h1 className="text-lg font-semibold">{t("total_amount")}:</h1>
            <span className="text-lg">
              {`${enableCurrency?.unit || ""} `} RS <span> </span>
              {formik.values?.totalAmount.toLocaleString("en-IN")}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
